// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  UsageDayCycleResponse,
  UsageDayCycleResponseT,
  verifyUsageDayCycleResponse,
} from "./usage-day-cycle-response";

export class UsageDayCycleResponses implements flatbuffers.IUnpackableObject<UsageDayCycleResponsesT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): UsageDayCycleResponses {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUsageDayCycleResponses(
    bb: flatbuffers.ByteBuffer,
    obj?: UsageDayCycleResponses,
  ): UsageDayCycleResponses {
    return (obj || new UsageDayCycleResponses()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsUsageDayCycleResponses(
    bb: flatbuffers.ByteBuffer,
    obj?: UsageDayCycleResponses,
  ): UsageDayCycleResponses {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new UsageDayCycleResponses()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  results(index: number, obj?: UsageDayCycleResponse): UsageDayCycleResponse | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new UsageDayCycleResponse()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  resultsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startUsageDayCycleResponses(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addResults(builder: flatbuffers.Builder, resultsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, resultsOffset, 0);
  }

  static createResultsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startResultsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endUsageDayCycleResponses(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // results
    return offset;
  }

  static createUsageDayCycleResponses(
    builder: flatbuffers.Builder,
    resultsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    UsageDayCycleResponses.startUsageDayCycleResponses(builder);
    UsageDayCycleResponses.addResults(builder, resultsOffset);
    return UsageDayCycleResponses.endUsageDayCycleResponses(builder);
  }

  unpack(): UsageDayCycleResponsesT {
    return new UsageDayCycleResponsesT(
      this.bb!.createObjList<UsageDayCycleResponse, UsageDayCycleResponseT>(
        this.results.bind(this),
        this.resultsLength(),
      ),
    );
  }

  unpackTo(_o: UsageDayCycleResponsesT): void {
    _o.results = this.bb!.createObjList<UsageDayCycleResponse, UsageDayCycleResponseT>(
      this.results.bind(this),
      this.resultsLength(),
    );
  }

  unpackFields(...fields: string[]): UsageDayCycleResponsesT {
    const t = new UsageDayCycleResponsesT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("results")) {
      t.results = this.bb!.createObjList<UsageDayCycleResponse, UsageDayCycleResponseT>(
        this.results.bind(this),
        this.resultsLength(),
      );
    }
    return t;
  }
}

export class UsageDayCycleResponsesT implements flatbuffers.IGeneratedObject {
  constructor(public results: UsageDayCycleResponseT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.results === null || this.results === undefined) {
      throw new Error('Required field "results" is not set');
    }
    const results = UsageDayCycleResponses.createResultsVector(
      builder,
      builder.createObjectOffsetList(this.results),
    );

    return UsageDayCycleResponses.createUsageDayCycleResponses(builder, results);
  }

  clone(): UsageDayCycleResponsesT {
    const obj = new UsageDayCycleResponsesT();
    obj.results = this.results.map((e) => e.clone());
    return obj;
  }

  equals(other: UsageDayCycleResponsesT): boolean {
    if (this.results.length !== other.results.length) return false;
    for (let i = 0; i < this.results.length; i++) {
      const a = this.results[i];
      const b = other.results[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyUsageDayCycleResponses(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUsageDayCycleResponse);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "results");
  } finally {
    verifier.popDepth();
  }
}
